import { find } from 'lodash/fp';

const getMlsThreshold = ({ income, thresholds }: { income: number; thresholds: any }) =>
  find((obj) => income >= obj.min && income <= obj.max, thresholds);
export default getMlsThreshold;
